import { useState, VFC } from 'react'
import { KeepIcon } from 'src/assets/svgs'
import { UserIcon } from 'src/components/Image/UserIcon'
import { black, orange, truewhite } from 'src/styles/colors'
import { fontWeightBold, fontWeightRegular } from 'src/styles/font'
import styled, { css } from 'styled-components'
import { FeedbackScore } from '../Rating/FeedbackScore'
import { Label } from './styles'
import { ProfilePreviewProps } from './types'

export const ProfileHeader: VFC<ProfilePreviewProps> = ({
  user: {
    id,
    profile: { iconSrc, name, position, isCertified },
    company: {
      name: companyName,
      foundedOn,
      prefecture,
      numberOfEmployees,
      capital,
      isListed,
      feedbackScore,
      feedbackCount,
    },
    kept,
  },
  onClickKeep,
  displayCertified,
}) => {
  const [keptFlag, setKeptFlag] = useState<boolean | undefined>(kept)

  const onClick = async (id: number) => {
    if (onClickKeep)
      if (keptFlag) {
        await onClickKeep(id, true)
        setKeptFlag(false)
      } else {
        await onClickKeep(id, false)
        setKeptFlag(true)
      }
  }

  return (
    <Header>
      <ProfileIcon src={iconSrc} alt={name} size="80px" />
      <div>
        <CompanyName>{companyName}</CompanyName>
        <UserName>{name}</UserName>
        {position && <LabelSmall>{position}</LabelSmall>}
        {displayCertified && isCertified !== false && (
          <LabelSmall backgroundColor={orange}>有料会員</LabelSmall>
        )}
        <FeedbackScoreDiv>
          <FeedbackScore value={feedbackScore} feedbackCount={feedbackCount} />
        </FeedbackScoreDiv>
        <CompanyAttributes>
          {[
            prefecture,
            foundedOn &&
              `設立年数： ${new Date().getFullYear() - +foundedOn} 年`,
            numberOfEmployees && `従業員数： ${numberOfEmployees}`,
            capital && `資本金： ${capital}`,
            isListed != null && (isListed ? '上場' : '未上場'),
          ]
            .filter(Boolean)
            .join(' / ')}
        </CompanyAttributes>
      </div>
      {onClickKeep && (
        <Needs>
          <NeedsContain>
            <KeepButton
              kept={keptFlag ? true : false}
              onClick={() => onClick(id)}
            >
              <KeepIcon />
              <span>{keptFlag ? '保存済み' : '保存する'}</span>
            </KeepButton>
          </NeedsContain>
        </Needs>
      )}
    </Header>
  )
}
const Header = styled.div`
  display: flex;

  font-size: 12px;
  line-height: 1;
  color: ${truewhite};
  font-weight: ${fontWeightBold};
  background-color: ${black};
  padding: 12px 5% 12px 0;

  @media screen and (min-width: 640px) {
    font-size: 16px;
  }
  > div {
    :first-child {
      width: 25%;
      > * {
        display: block;
        margin: auto;
      }
    }
    :nth-child(2) {
      flex: 1;
    }
  }
`
const ProfileIcon = styled(UserIcon)`
  display: block;
  margin: auto 10px;
`
const CompanyName = styled.p`
  font-size: 1em;
  line-height: 1;
`

const UserName = styled.p`
  font-size: 1.25em;
  line-height: 1.4;
`

const LabelSmall = styled(Label)`
  font-size: 10px;
`

const CompanyAttributes = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dotted;

  font-size: 15px;
  font-weight: ${fontWeightRegular};
  line-height: 1.4;
  letter-spacing: 0.05em;
`

const Needs = styled.div`
  height: 100%;
  width: 66px;
`

const NeedsContain = styled.div``
const KeepButton = styled.button<{ kept: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  border-radius: 25px;
  background-color: #ff6c00;
  z-index: 1;
  min-width: 70px;
  font-size: 12px;
  color: #ffffff;
  border: 1px solid #ff6c00;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  font-weight: bold;
  svg {
    margin-right: 3px;
    fill: #ffffff;
  }
  ${({ kept }) =>
    !kept &&
    css`
      background-color: #fff;
      color: #838383;
      border: 1px solid #838383;
      svg {
        margin-right: 3px;
        fill: #838383;
      }
    `}
`

const FeedbackScoreDiv = styled.div`
  padding-top: 4px;
  padding-bottom: 4px;
`
